// 请求模块统一入口 - 遵循开闭原则

import { 
  httpWithRetry, 
  isNetworkConnected
} from './http-with-retry';

// 导入必要的类型
import type {
  HttpWithRetryOptions,
  HttpWithRetryResponse,
} from './http/types';


export const request = {
  send: async (url: string, options?: HttpWithRetryOptions): Promise<HttpWithRetryResponse> => {
    return await httpWithRetry(url, options);
  },
  isOnline: (): boolean => isNetworkConnected()
};

// 只导出用户真正需要的类型
export type {
  HttpWithRetryOptions,
  HttpWithRetryResponse,
};

// 默认导出
export default request;
